import cx from "classnames";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { BackToIcon, CloseIcon } from "@/icons";
import styles from "../PresentationsWindow.module.scss";

export const PresentationHeader = memo(
    ({
        presentation,
        onBack,
        onClose,
        hideBack,
    }: {
        presentation: boolean;
        onBack: () => void;
        onClose: () => void;
        hideBack: boolean;
    }) => {
        const { t } = useTranslation();
        return (
            <div className={styles.slidesHeader}>
                <div className={cx(styles.slidesHeaderContainer, hideBack && styles.hiddenBack)}>
                    {presentation ? (
                        <button
                            type="button"
                            className={styles.presentationHeaderIcon}
                            onClick={onBack}
                        >
                            <BackToIcon />
                        </button>
                    ) : (
                        <h2 className={styles.slidesTitle}>{t("presentations.title")}</h2>
                    )}
                    <button
                        className={styles.presentationHeaderIcon}
                        type="button"
                        onClick={onClose}
                    >
                        <CloseIcon className={styles.closeIcon} />
                    </button>
                </div>
                <div className={styles.divider}></div>
            </div>
        );
    },
);
